<template>
    <div>
<footer class="footer">
      <div class="footer-content">
        <div
          class="content-item"
          v-for="(item, index) in footList"
          :key="index"
        >
          <div class="footer-category-title">{{ item.title }}</div>
          <div class="footer-category-subtitle">{{ item.subtitle }}</div>
          <ol>
            <li v-for="(v, i) in item.categoryList" :key="i" @click="categoryItemClick(v)">{{ v.text }}</li>
          </ol>
        </div>
        <div class="qrcode">
          <img
            class="qrcode-img"
            src="../assets/images/index/qrcode.png"
            alt=""
          />
          <div class="qrcode-text">澜城数据官方公众号</div>
        </div>
      </div>
      <div class="goTop-wechat">
        <div class="goTop" @click="goTopClick" v-if="isShow">
          <div class="goTop-active"></div>
        </div>
        <div class="wechat">
          <div class="wechat-active"></div>
          <!-- official account -->
          <div class="official-account">
            <div class="afficial-text">澜城数据官方公众号</div>
            <img src="../assets/images/index/offical.png" alt="" />
            <div class="search">搜索关注</div>
            <div class="cityData">澜城数据City Wave Data</div>
          </div>
        </div>
      </div>
    </footer>
    <!-- end -->
    <div class="end">
      <div class="copyright">
        Copyright <span>&copy;</span> 2005-2022 {{webchatUrl}} All right reserved
      </div>
      <div class="icp">
        <a href="https://beian.miit.gov.cn/" target="_blank">
          {{webchatUrl === 'www.citywavedata.com' ? '沪ICP备10019506号-8' : '沪ICP备10019506号-7'}}
        </a>
      </div>
    </div>
    </div>
</template>


<script>
export default {
  data() {
    return {
      footList: [
        {
          title: "新手入门",
          subtitle: "Beginner'sGuide",
          categoryList: [
            {
              text: "关于我们"
            },
            {
              text: "产品介绍"
            },
            {
              text: "一房一万"
            }
          ]
        },
        {
          title: "商务合作",
          subtitle: "Business Cooperation",
          categoryList: [
            {
              text: "商务合作"
            }
          ]
        },
        {
          title: "相关协议",
          subtitle: "Related Agreements",
          categoryList: [
            {
              text: "服务条款"
            },
            {
              text: "隐私政策"
            }
          ]
        }
      ],
      scrollTop: 100,
      isShow: false,
      webchatUrl: ''
    };
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      // console.log(this.scrollTop)    // 3300
      if (this.scrollTop > window.innerHeight) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    goTopClick() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 10);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
    categoryItemClick(v) {
      if (v.text == "商务合作") {
        this.$router.push("./businessCooperation");
        this.goTopClick()
      } else if (v.text == "关于我们") {
        this.$router.push("./aboutUs");
        this.goTopClick()
      } else if (v.text == "服务条款") {
        this.$router.push("./privacyAgreement");
      } else if (v.text == "隐私政策") {
        this.$router.push("./disclaimers");
      } else if(v.text == "产品介绍") {
        this.$router.push("./productIntroOpenPlatform");
        this.goTopClick()
      } else if(v.text == "一房一万") {
        // 新增一房一万官网外链
        window.open("https://www.realtynavi.com/", "_blank")
      }
    }
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.webchatUrl = window.document.location.host
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 284px;
  background: #021a3c;
  position: relative;

  .footer-content {
    width: 1140px;
    height: 284px;
    margin: 0 auto;
    overflow: hidden;

    .content-item {
      width: 25%;
      height: 284px;
      margin-top: 32px;
      float: left;

      .footer-category-title {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
      }

      .footer-category-subtitle {
        margin-top: 21px;
        color: #3880f4;
        font-size: 14px;
        font-style: italic;
        position: relative;

        &::after {
          content: "";
          width: 32px;
          height: 1px;
          background: #d8d8d8;
          position: absolute;
          bottom: -34px;
          left: 0;
        }
      }

      ol {
        margin-top: 66px;

        li {
          margin-bottom: 12px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          cursor: pointer;

          &:hover {
            color: #3880f4;
          }
        }
      }
    }

    .qrcode {
      width: 25%;
      height: 284px;
      float: left;

      .qrcode-img {
        width: 148px;
        height: 148px;
        display: block;
        margin: 0 auto;
        margin-top: 32px;
      }

      .qrcode-text {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 20px;
        margin-top: 13px;
        opacity: 0.65;
      }
    }
  }

  .goTop-wechat {
    width: 56px;
    height: 120px;
    position: absolute;
    bottom: 130px;
    right: 16px;

    .goTop {
      width: 54px;
      height: 54px;
      width: 56px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid rgba(2, 26, 60, 0.25);
      position: fixed;
      bottom: 122px; // 239
      right: 16px;
      cursor: pointer;

      .goTop-active {
        width: 32px;
        height: 32px;
        background: url("../assets/images/index/goTop.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &:hover .goTop-active {
        background: url("../assets/images/index/goTop_active.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .wechat {
      width: 54px;
      height: 54px;
      width: 56px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid rgba(2, 26, 60, 0.25);
      position: fixed;
      bottom: 56px; // 173
      right: 16px;
      cursor: pointer;

      &:hover .wechat-active {
        background: url("../assets/images/index/wechat_active.png") no-repeat;
        background-size: 100% 100%;
      }

      &:hover {
        .official-account {
          display: block;
        }
      }

      .wechat-active {
        width: 32px;
        height: 32px;
        background: url("../assets/images/index/wechat.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .official-account {
        width: 171px;
        height: 179px;
        background: #fff;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
        // overflow: hidden;
        position: absolute;
        bottom: -1px; // -124
        right: 58px; // 57
        display: none;

        &::before {
          content:"";
          position:absolute;
          top: 142px;
          right: -4px;
          border-left: 8px solid #fff;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }

        .afficial-text {
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          text-align: center;
          color: #272727;
          line-height: 17px;
          margin-top: 16px;
        }

        img {
          width: 80px;
          height: 80px;
          display: block;
          margin: 8px auto;
        }

        .search {
          font-size: 12px;
          text-align: center;
          color: #666;
        }

        .cityData {
          font-size: 12px;
          text-align: center;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3880f4;
          line-height: 17px;
        }
      }
    }
  }
}

.end {
  width: 100%;
  height: 44px;
  background: #021a3c;
  box-shadow: 0px 1px 0px 0px rgba(255, 255, 255, 0.06);
  border-top: 1px solid #0e2545;

  .copyright,
  .icp {
    width: 50%;
    height: 44px;
    float: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: right;
    line-height: 44px;
    opacity: 0.45;
  }

  .icp {
    text-align: left;
    a {
      margin-left: 80px;
      color: #ffffff;
      text-decoration: none;
    }
  }
}
</style>

